<template>
  <ion-page>
    <ion-tabs v-if="sharedState.ui" :key="sharedState.language">
      <AppHeader slot="top" />
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom" dir="ltr">

        <ion-tab-button tab="tab1" href="/home">
          <ion-icon :icon="home" />
          <ion-label v-html="sharedState.ui.tabs.home"></ion-label>
        </ion-tab-button>
          
        <ion-tab-button tab="tab2" href="/resources">
          <ion-icon :icon="folder" />
          <ion-label v-html="sharedState.ui.tabs.resources"></ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="tab3" href="/bookmarks">
          <ion-icon :icon="bookmark" />
          <ion-label v-html="sharedState.ui.tabs.bookmark"></ion-label>
        </ion-tab-button>

        <ion-tab-button v-if="sharedState.deviceType === 'ios' || sharedState.deviceType === 'android'" tab="tab4" href="/calendar">
          <ion-icon :icon="calendar" />
          <ion-label v-html="sharedState.ui.tabs.calendar"></ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab5" href="/settings">
          <ion-icon :icon="settings" />
          <ion-label v-html="sharedState.ui.tabs.settings"></ion-label>
        </ion-tab-button>

      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
import { IonRouterOutlet, IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage } from '@ionic/vue';
import { home, folder, bookmark, settings, calendar } from 'ionicons/icons';
import AppHeader from '@/components/AppHeader.vue';
import { store } from '@/store';

export default {
  name: 'Tabs',
  components: { AppHeader, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage },
  setup() {
    return {
      home,
      folder,
      bookmark,
      settings,
      calendar
    }
  },
  data() {
    return {
      sharedState: store.state,
    }
  },
  async mounted() {
    const lang = await store.getLanguage();
    const dir = (lang == 'ar' || lang == 'fa') ? 'rtl' : 'ltr';
    this.$el.querySelector('ion-router-outlet').setAttribute('dir', dir);
  }
}
</script>